import { strings } from "@quickpoint.me/shared";

export interface QpSessionHistory {
    entry: string;
    crumbs: string[];
}

interface QpLocalHistory {
    [key: string]: QpSessionHistory;
}

type HistoryKey = typeof strings.localStorage.QpHistorySessionStorage | typeof strings.localStorage.QpHistoryLocalStorage;


// this recoird only exist in a session and records any navigation with quickpoint.com
export function recordHistory({ entry, goingTo }: { entry: string, goingTo: string }) {
    let sessionHistory = getSessionStorageHistory();
    // sessionHistory exists so append crumb
    if (sessionHistory) {
        sessionHistory.crumbs.push(goingTo);
        writeSessionStorageHistory(sessionHistory);
    } else {
        // first naviagation create a record.
        sessionHistory = {
            entry: entry,
            crumbs: [goingTo],
        }
        writeSessionStorageHistory(sessionHistory);
    }

    // copy this session to local storage
    writeLocalStorageHistory(sessionHistory);


}

export function writeLocalStorageHistory(value: QpSessionHistory) {
    const sessionHistory = getLocalStorageHistory();
    if (sessionHistory) {
        sessionHistory[value.entry] = value;
        localStorage.setItem(strings.localStorage.QpHistoryLocalStorage, JSON.stringify(sessionHistory));
    } else {
        const newHistory: QpLocalHistory = {};
        newHistory[value.entry] = value
        localStorage.setItem(strings.localStorage.QpHistoryLocalStorage, JSON.stringify(newHistory));
    }
}




export function removeLocalStorageHistory(key: HistoryKey) {
    localStorage.removeItem(key);
}

export function getLocalStorageHistory(): false | QpLocalHistory {
    const res = localStorage.getItem(strings.localStorage.QpHistoryLocalStorage);
    if (res) {
        return JSON.parse(res);
    } else {
        return false;
    }
}


export function writeSessionStorageHistory(value: QpSessionHistory) {
    sessionStorage.setItem(strings.localStorage.QpHistorySessionStorage, JSON.stringify(value));
}


export function removeSessionStorageHistory(key: HistoryKey) {
    sessionStorage.removeItem(key);
}

export function getSessionStorageHistory(): false | QpSessionHistory {
    const res = sessionStorage.getItem(strings.localStorage.QpHistorySessionStorage);
    if (res) {
        return JSON.parse(res);
    } else {
        return false;
    }
}


// key is stackCfKey
export function getLastPageRead(key: string): number | false {
    const page = localStorage.getItem(key);
    return page ? parseInt(page) : false
}

// key is stackCfKey
export function setLastPageRead(key: string, pageIndex: number) {
    localStorage.setItem(key, pageIndex.toString());
}
